type ContentItem = {
  text: string;
  href?: string;
};

export const tosContent: ContentItem[][] = [
  [{ text: 'Operated by Atlassian' }],
  [
    {
      text: 'Atlassian Privacy Statement',
      href: 'https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers',
    },
    {
      text: 'Microsoft Privacy Statement',
      href: 'https://www.microsoft.com/en-us/privacy/privacystatement',
    },
    {
      text: 'Microsoft Consumer Health Privacy',
      href: 'https://www.microsoft.com/en-us/privacy/microsoft-consumer-health-data-privacy-policy',
    },
  ],
  [
    {
      text: 'Minecraft Terms of Use',
      href: 'https://www.minecraft.net/en-us/eula',
    },
    {
      text: 'Atlassian Terms of Use',
      href: 'https://www.atlassian.com/legal/atlassian-customer-agreement#intro',
    },
  ],
];
